module.exports = __webpack_public_path__ + "static/media/old-logo.376e0ef4.png";